(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["jm-header-actions"] && !Shopify.designMode) return;
  try {
    if (!window.jmHeaderSignupBound) {
    window.jmHeaderSignupBound = true;
    document.addEventListener('click', function (event) {
      const button = event.target.closest('[data-jm-signup-dialog]');
      if (!button || button.disabled) return;
      const dialog = document.getElementById(button.dataset.jmSignupDialog);
      if (!dialog || dialog.open) return;
      dialog.showModal();
    });
    document.addEventListener('click', function (event) {
      const dialog = event.target;
      if (!dialog.matches('.jm-header-actions__email-dialog[open]')) return;
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
    });
    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      const openMenu = document.querySelector('.jm-header-actions__app[open]');
      if (!openMenu) return;
      openMenu.open = false;
      openMenu.querySelector('summary').focus();
    });
    document.addEventListener('click', function (event) {
      document.querySelectorAll('.jm-header-actions__app[open]').forEach(function (menu) {
        if (!menu.contains(event.target)) menu.open = false;
      });
    });
  }
  } catch(e) { console.error(e); }
})();

})();
